module.exports = __webpack_public_path__ + "static/media/product-left-nav.950e5bcd.svg";